import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType, Effect } from '@ngrx/effects';
import {
  map,
  catchError,
  concatMap,
  exhaustMap,
  switchMap,
  mergeMap,
  takeUntil,
} from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import * as EpimsGateActions from './anchorepimsgates.actions';

import { StakeholderReferenceDto } from '@cradua/data';
import { AnchorEPIMsService } from '../../services/anchorepimsgates.service';
import { Action } from '@ngrx/store';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { serializeError } from 'serialize-error';

@Injectable()
export class AnchorEPIMSEffects {
  mainActionType: string;

  public SetActionType(type: string) {
    this.mainActionType = type;
  }

  // loadStakeholderReference$ = createEffect(() =>
  // 	this.actions$.pipe(
  // 		ofType(StakeholderReferenceActions.loadStakeholderReference),
  // 		exhaustMap((_) =>
  // 			this.stakeholderreferenceService.getStakeholderReference("Club").pipe(
  // 				map((data) => {
  // 					console.log('data from database ', data);
  // 					return StakeholderReferenceActions.loadStakeholderReferenceSuccess({ stakeholderreference: data });
  // 				}),
  // 				catchError((error) => of(StakeholderReferenceActions.loadStakeholderReferenceFailure({ error })))
  // 			)
  // 		)
  // 	)
  // );

  protected loadAllData = (actions, type) => {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.loadEpimsgate(type)),
      mergeMap((action) =>
        this.epimsgatesService.getAll(type).pipe(
          map((data) => {
            console.log('Generic Data ', type, data);
            return actions.loadEpimsgateSuccess(type)({ returnedData: data });
          }),
          catchError((error) =>
            of(actions.loadEpimsgateFailure(type)({ error }))
          )
        )
      )
    );

    return fn;
  };

  protected add = (actions, type) => {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.addViaEpimsgate(type)),
      concatMap(({ dataToAdd }) =>
        this.epimsgatesService.createData(type, dataToAdd).pipe(
          map((data) =>
            actions.addViaEpimsgateSuccess(type)({ newStakeholder: data })
          ),
          catchError((error) =>
            of(
              actions.addStakeholderFailure(type)({
                error: error.error.message,
              })
            )
          )
        )
      )
    );

    return fn;
  };

  protected update = (actions, type) => {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.updateViaEpimsgate(type)),
      concatMap(({ dataToAdd, deletedData }) =>
        this.epimsgatesService.updateData(type, dataToAdd, deletedData).pipe(
          map((data) =>
            actions.updateViaEpimsgateSuccess(type)({ returnedData: data })
          ),
          catchError((error) =>
            of(
              actions.updateViaEpimsgateFailure(type)({
                error: error.error.message,
              })
            )
          )
        )
      )
    );

    return fn;
  };

  protected remove = (actions, type) => {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.removeViaEpimsgate(type)),
      concatMap(({ ids }) =>
        this.epimsgatesService.deleteData(type, ids).pipe(
          map((data) => actions.removeViaEpimsgateSuccess(type)({ ids: data })),
          catchError((error) =>
            of(
              actions.updateViaEpimsgateFailure(type)({
                error: error.error.message,
              })
            )
          )
        )
      )
    );

    return fn;
  };

  // @Effect()
  // uploadRequestEffect$: Observable<Action> = this.actions$.pipe(
  //   ofType(EpimsGateActions.documentUploadRequest),
  //   concatMap(({ file, document}) =>
  // 	this.epimsgatesService.uploadFile(file, document,'Document').pipe(

  // 	  takeUntil(
  // 		this.actions$.pipe(
  // 		  ofType(EpimsGateActions.documentUploadCancel)
  // 		)
  // 	  ),
  // 	  map(event => this.getActionFromHttpEvent(event)),
  // 	  catchError(error => of(this.handleError(error)))
  // 	)
  //   )
  // );

  protected uploadRequestEffect = (actions, type) => {
    console.log('Upload Document Effect Created');
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(EpimsGateActions.documentUploadRequest),
      mergeMap(({ file, document }) =>
        this.epimsgatesService.uploadFile(file, document, 'Document').pipe(
          takeUntil(
            this.actions$.pipe(ofType(EpimsGateActions.documentUploadCancel))
          ),
          map((event) => this.getActionFromHttpEvent(event)),
          catchError((error) => of(this.handleError(error)))
        )
      )
    );

    return fn;
  };

  // loadEpimsGate$ = createEffect(() =>
  // 	this.actions$.pipe(
  // 		ofType(EpimsGateActions.loadEpimsgate('Club')),
  // 		mergeMap((action) =>
  // 			this.epimsgatesService.getAll("Club").pipe(
  // 				map((data) => {

  // 					console.log("Generic Data ", data);
  // 				  return EpimsGateActions.loadEpimsgateSuccess('Club')({returnedData: data} );
  // 				}),
  // 				catchError((error) =>  of(EpimsGateActions.loadEpimsgateFailure('Club')({ error })) )
  // 			)

  // 		)
  // 	)
  // );
  loadEpimsGateEngagement$ = createEffect(() =>
    this.loadAllData(EpimsGateActions, 'Engagement')
  );

  loadEpimsGate$ = createEffect(() =>
    this.loadAllData(EpimsGateActions, 'Language')
  );

  loadEpimsGateClub$ = createEffect(() =>
    this.loadAllData(EpimsGateActions, 'Club')
  );

  addEpimsGateEngagement$ = createEffect(() =>
    this.add(EpimsGateActions, 'Engagement')
  );
  updateEpimsGateEngagement$ = createEffect(() =>
    this.update(EpimsGateActions, 'Engagement')
  );

  loadEpimsGateDocuments$ = createEffect(() =>
    this.loadAllData(EpimsGateActions, 'Document')
  );
  updateUploadDocument$ = createEffect(() =>
    this.uploadRequestEffect(EpimsGateActions, 'Document')
  );

  updateDocument$ = createEffect(() =>
    this.update(EpimsGateActions, 'Document')
  );

  private getActionFromHttpEvent(event: HttpEvent<any>) {
    console.log('Reaching Action from HttpEvent');
    switch (event.type) {
      case HttpEventType.Sent: {
        return EpimsGateActions.documentUploadStarted();
      }
      case HttpEventType.UploadProgress: {
        return EpimsGateActions.documentUploadProgress({
          progress: Math.round((100 * event.loaded) / event.total),
        });
      }
      case HttpEventType.ResponseHeader:
      case HttpEventType.Response: {
        if (event.status === 200) {
          return EpimsGateActions.documentUploadCompleted();
        } else {
          return EpimsGateActions.documentUploadFailure({
            error: event.statusText,
          });
        }
      }
      default: {
        return EpimsGateActions.documentUploadFailure({
          error: `Unknown Event: ${JSON.stringify(event)}`,
        });
      }
    }
  }

  private handleError(error: any) {
    const friendlyErrorMessage = serializeError(error).message;
    return EpimsGateActions.documentUploadFailure({
      error: friendlyErrorMessage,
    });
  }

  constructor(
    private actions$: Actions,
    private epimsgatesService: AnchorEPIMsService
  ) {}
}
